import { JsonObject, JsonProperty } from 'json2typescript';

import { Civility, ClientType } from '@features/termination/enums';
import { DateConverter } from '@shared/converters';

@JsonObject('client')
export class Customer {
  @JsonProperty('civilite', Number, true)
  public gender = 0;

  @JsonProperty('dateNaissance', DateConverter, true)
  public dateOfBirth?: Date = undefined;

  @JsonProperty('ikpiPersonne', String, true)
  public personIkpi = '';

  @JsonProperty('nomComplet', String, true)
  public name = '';

  @JsonProperty('prenom', String, true)
  public firstName = '';

  public get isPhysicalPerson(): boolean {
    return this.personIkpi.substring(0, 2) === ClientType.PHYSICAL_PERSON;
  }

  public get fullName(): string {
    if (this.isPhysicalPerson) {
      switch (this.gender) {
        case Civility.MISTER:
          return this.name.substring(3);
        case Civility.MADAM:
          return this.name.substring(4);
        default:
          return this.name.substring(5);
      }
    } else {
      return this.name;
    }
  }

  public get genderWithMissCivilityFiltered(): number {
    return this.gender === Civility.MISS ? Civility.MADAM : this.gender;
  }

  public get identification(): string {
    return this.personIkpi.substring(0, 2);
  }
}
